import { render, staticRenderFns } from "./support4iQ.vue?vue&type=template&id=9fd3365e&"
import script from "./support4iQ.vue?vue&type=script&lang=js&"
export * from "./support4iQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fd3365e')) {
      api.createRecord('9fd3365e', component.options)
    } else {
      api.reload('9fd3365e', component.options)
    }
    module.hot.accept("./support4iQ.vue?vue&type=template&id=9fd3365e&", function () {
      api.rerender('9fd3365e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/Login/support4iQ.vue"
export default component.exports